import { ValueObject, NeoModel, Attributes, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class FileGroupingFileSpecImportProcedureLookup extends ValueObject {
    public fileGroupingFileSpecImportProcedureId: number | null = null;

    public staticServiceProviderFileGroupingId: number | null = null;

    public staticServiceProviderFileGroupingFileSpecId : number = 0;

    @Rules.Required()
    public importProcedureId: number | null = null;

    public stockbrokerName: string = "";

    public fileType : string = "";

    public staticFileSpecID: number | null = null;

    @Attributes.Date()
    public activeStartDate: Date | null = null;

    @Attributes.Date()
    public activeEndDate: Date | null = null;
    
    public storedProcedure: string = "";

    public process: string = "";

    @Attributes.Integer()
    public priority: number | null = null;

    public normaliseInd: boolean = false;

    public extractionInd: boolean = false;

    public dataInterceptionInd: boolean = false;

    public filterClause: string = "";

    public joinClause: string = "";

    public processTypeID: number | null = null;

    public getAllImportProcedures: boolean = false;
}